// extracted by mini-css-extract-plugin
export default {"container":"PaymentOptionsView_container__FgEJy","stripeLogo":"PaymentOptionsView_stripeLogo__gBb9j","placeHolder":"PaymentOptionsView_placeHolder__Mgpgp"};